// extracted by mini-css-extract-plugin
export default {"container":"WUwrR","description":"_3P8e4","checkboxContainer":"N+26g","alert":"lpnAc","sectionNotificationContainer":"l2nfN","labelContainer":"dDCZu","error":"AcJas"};